import React, { useContext } from 'react';
import Props from '../../types/props';
import Box from '../single_component/Box';
import Dpicker from '../single_component/Dpicker';
import Dropdown from '../common_component/Dropdown';
import MultipleChip from '../common_component/MultipleChip';
import TwoButton from '../common_component/TwoButton';
import AuthContext from '../../context/AuthContext';

function SaleDashFilter({ ...props }: Props) {
  const { masterData } = useContext(AuthContext);
  const data = masterData?.value();

  const {
    StartDate,
    setStartDate,
    EndDate,
    setEndDate,
    duration,
    setDuration,
    durationNames,
    selectedChip,
    setSelectedChip,
    fetchData,
  } = props?.extra ?? {};

  const onCancel = () => {
    setSelectedChip(-1);
    setStartDate(null);
    setEndDate(null);
    setDuration(2);
  };

  const handleChipClick = (index: number) => {
    setSelectedChip(index);
  };

  return (
    <Box style={{ display: 'flex', justifyContent: 'center' }}>
      <Box style={{ width: '90%', alignSelf: 'center', paddingBottom: 9 }}>
        <Box style={{ marginTop: 2, marginBottom: 1 }}>
          <Dropdown
            label="Duration"
            value={durationNames[duration] ?? ''}
            name="duration"
            id="duration"
            onChange={(e: any) => setDuration(e.target.value)}
            extra={{
              options: durationNames?.map((e: any) => ({ name: e })),
              placeholder: 'Select duration',
            }}
          />
        </Box>

        <Dpicker
          extra={{
            setDate: setStartDate,
            placeholder: 'Select start date',
          }}
          value={StartDate}
          style={{ width: '100%', marginTop: 2, marginBottom: 1 }}
          label="Start Date"
        />

        <Dpicker
          extra={{
            setDate: setEndDate,
            placeholder: 'Select end date',
            minDate: StartDate || undefined,
          }}
          value={EndDate}
          style={{ width: '100%', marginTop: 2, marginBottom: 1 }}
          label="End Date"
        />

        <MultipleChip
          style={{ width: '100%', marginTop: 2, marginBottom: 1 }}
          label="Status"
          extra={{
            handleClick: handleChipClick,
            options: data?.transactionStatus,
            variant: 'outlined',
            clickable: true,
            selectedChip: selectedChip,
          }}
        />

        <TwoButton
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            bottom: 10,
            position: 'absolute',
            width: '90%',
          }}
          extra={{
            onclickFirst: onCancel,
            OnClickSecond: fetchData,
            firstVariant: 'outlined',
            secondVariant: 'contained',
            firstButtonText: 'Clear filter',
            secondButtonText: 'Apply',
          }}
        />
      </Box>
    </Box>
  );
}

export default SaleDashFilter;
